import type { OrchestrationEvent } from "@amoreg/contracts";

/** File updates already travel on the scoped thread stream. Use its sequence,
 * not a filename or wall-clock timestamp: two replacements can share both. */
export function workspaceRevisionFromEvent(event: OrchestrationEvent): string | undefined {
  return event.type === "thread.meta-updated" && event.payload.worktreePath !== undefined
    ? `event:${event.sequence}`
    : undefined;
}
